import { render, staticRenderFns } from "./ModalDescricaoNd.vue?vue&type=template&id=1970fd64"
import script from "./ModalDescricaoNd.vue?vue&type=script&lang=js"
export * from "./ModalDescricaoNd.vue?vue&type=script&lang=js"
import style0 from "./ModalDescricaoNd.vue?vue&type=style&index=0&id=1970fd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports